import { render, staticRenderFns } from "./ListRequiredDocuments.vue?vue&type=template&id=0b25360b&scoped=true&"
import script from "./ListRequiredDocuments.vue?vue&type=script&lang=js&"
export * from "./ListRequiredDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ListRequiredDocuments.vue?vue&type=style&index=0&id=0b25360b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b25360b",
  null
  
)

export default component.exports